import _styled from "@emotion/styled-base";
import { css } from '@emotion/core';
import { media, applyFont, tokens } from '@domain-group/fe-brary';
var typography = tokens.typography,
  colors = tokens.colors;
export var Icons = _styled("div", {
  target: "etrbpx50"
})(applyFont(typography.bodyBold), ";display:flex;flex-direction:column;gap:16px;", media('>=desktop'), "{flex-direction:row;}");
export var FeatureIconContainer = _styled("div", {
  target: "etrbpx51"
})({
  name: "4wkthe",
  styles: "display:flex;gap:22px;"
});
export var PropertyTypeLabel = _styled("span", {
  target: "etrbpx52"
})("&::after{content:'\u2022';margin-left:12px;margin-right:12px;color:", colors.neutral.trim.default, ";}");
export var Item = _styled("span", {
  target: "etrbpx53"
})({
  name: "85ghxj",
  styles: "white-space:nowrap;display:flex;align-items:center;gap:2px;"
});
export var Value = _styled("span", {
  target: "etrbpx54"
})({
  name: "1qkvt8e",
  styles: "margin-right:2px;"
});
export var itemIcon = {
  name: "1ai6qls",
  styles: "margin:-2px 2px -2px 0;vertical-align:bottom;"
};
export var MobileFirstRow = _styled("div", {
  target: "etrbpx55"
})({
  name: "v9cqie",
  styles: "display:flex;align-items:flex-start;justify-content:flex-start;vertical-align:middle;white-space:nowrap;"
});
export var MobileSecondRow = _styled("div", {
  target: "etrbpx56"
})(media('>=desktop'), "{border:none;border-left:1px solid ", colors.neutral.trim.default, ";padding-left:16px;}");